module.exports = __webpack_public_path__ + "assets/fonts/优设标题黑.1726685c.ttf";